// extracted by mini-css-extract-plugin
export default {"root":"ChallengeSidebarLabel_root__6aWbE","title":"ChallengeSidebarLabel_title__f+8LU","status":"ChallengeSidebarLabel_status__pmIXr"};